export default __webpack_public_path__ + "static/media/black-bishop.927ab679.png";